module.exports = __webpack_public_path__ + "img/img-yd-app-small.d825d80.svg";